var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table bg-white table-bordered" }, [
    _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _vm._m(0),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold", attrs: { scope: "col" } }, [
          _c("h6", { staticClass: "table-head" }, [
            _vm._v(_vm._s(_vm._f("trans")("First File"))),
          ]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold", attrs: { scope: "col" } }, [
          _c("h6", { staticClass: "table-head" }, [
            _vm._v(_vm._s(_vm._f("trans")("Second File"))),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Name")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.firstFile.filename))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.secondFile.filename))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Size")))])]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.setFileSize(this.firstFile.size)))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(" " + _vm._s(this.setFileSize(this.secondFile.size))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Height")))])]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.firstFile.metadata.image_height) + "px"),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.secondFile.metadata.image_height) + "px"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Width")))])]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.firstFile.metadata.image_width) + "px"),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.secondFile.metadata.image_width) + "px"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("File Type")))])]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(_vm.setFileType(this.firstFile.content_type))),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(_vm.setFileType(this.secondFile.content_type))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      { staticClass: "font-weight-bold", attrs: { scope: "col" } },
      [_c("h5")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }